
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kampanjer/[slug]",
      function () {
        return require("private-next-pages/kampanjer/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kampanjer/[slug]"])
      });
    }
  